import React, { useState, useEffect } from 'react';
import { SOLUTIONS_TASKS_COLUMNS } from 'constants/reports';
import { SolutionTaskData } from 'store/ducks/Reporting/types';
import { useFilterOptions } from 'utils/hooks/useFilterOptions';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import Helpers from 'utils/Helpers';
import ApiService from 'utils/ApiCalls';
import CustomTable from 'components/Tables/CustomTable';
import * as Styled from './SolutionsTasks.styled';

const SolutionsTasks: React.FC = () => {
  const { loading } = useFilterOptions();
  const [data, setData] = useState<SolutionTaskData[]>([]);

  const { orgContext, lang } = useSelector((state: RootState) => ({
    orgContext: state.global.hierarchicalLevelsScope,
    lang: state.global.lang
  }));

  const filterParams = Helpers.toApiFilters(orgContext);
  const normalizedFilters = Helpers.normalizeFilters(
    Helpers.toApiFilters(orgContext)
  );

  const handleDisplay = async () => {
    try {
      if (!orgContext || Object.keys(orgContext).length === 0) return;
      const hasFilters = Object.keys(filterParams).length > 0;
      if (!hasFilters) return;

      const response = await ApiService.getSolutionsTasks(
        lang,
        normalizedFilters
      );

      const responseData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      const formattedData = responseData.map(
        (item: SolutionTaskData, index: any) => {
          const tasks = Object.values(item.TASKS || {});

          return {
            ...item,
            key: item.sol_id || index,

            task_description: tasks.map((t: any) => t.task_description),
            task_type_name: tasks.map((t: any) => t.task_type_name),
            task_status_name: tasks.map((t: any) => t.task_status_name),
            task_owner_name: tasks.map((t: any) => t.task_owner_name),
            task_due_date: tasks.map((t: any) => t.task_due_date),
            task_created_by: tasks.map((t: any) => t.task_created_by),
            task_created_on: tasks.map((t: any) => t.task_created_on),
            task_owner_notified: tasks.map((t: any) => t.task_owner_notified)
          };
        }
      );
      setData(formattedData);
    } catch (error) {
      console.error('Failed to fetch Solutions Tasks data:', error);
    }
  };

  useEffect(() => {
    if (!lang) return;
    if (!orgContext || Object.keys(orgContext).length === 0) return;

    handleDisplay();
  }, [lang, orgContext]);

  return (
    <Styled.VerticalSpace direction='vertical' size='large'>
      <CustomTable
        drawTable={true}
        itemsCount={data.length}
        columns={SOLUTIONS_TASKS_COLUMNS}
        dataSource={data}
        scroll={{ x: 1600, y: 400 }}
        loading={loading}
        rowKey={(record: SolutionTaskData) => record.key}
        sticky
      />
    </Styled.VerticalSpace>
  );
};

export default SolutionsTasks;
